enum RequirementItemType {
    Existing = 'existing',
    Added = 'added',
};

export default RequirementItemType;